import { render, staticRenderFns } from "./InfoStoreComponent.vue?vue&type=template&id=e8ebaf22&"
import script from "./InfoStoreComponent.vue?vue&type=script&lang=js&"
export * from "./InfoStoreComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports